/**
 * antd 4 runtime theming. antd.variable.min.css (loaded in index.jsx) reads
 * its colours from CSS variables that ConfigProvider.config regenerates;
 * only the status colours are themeable this way, so surfaces are handled
 * in antd-overrides.css.
 */
import { ConfigProvider } from 'antd'

// Light keeps antd's own default so antd controls look as they did before themes.
const PRIMARY = {
  light: '#1890ff',
  dark: '#60a5fa',
  'ms-rt': '#1ab8ec',
  edc: '#4a2939',
}

export function applyAntdTheme(resolved) {
  ConfigProvider.config({ theme: { primaryColor: PRIMARY[resolved] || PRIMARY.light } })
}
